import { computed } from "vue";

export const useLocalization = () => {
    const countryAbbr = import.meta.env.VITE_LOCALIZATION_COUNTRY_ABBR;
    const currency = import.meta.env.VITE_LOCALIZATION_COUNTRY_CURRENCY;

    const isKeLocale = computed(() => {
        return countryAbbr.toLowerCase() === "ke";
    });

    const isNgLocale = computed(() => {
        return countryAbbr.toLowerCase() === "ng";
    });

    const locale = isNgLocale.value
        ? `en-${countryAbbr.toUpperCase()}`
        : 'en'

    const getCurrencyFormatter = (currency = 'NGN', locale = 'en-NG', maximumFractionDigits = 2) => {
        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
            maximumFractionDigits
        })
    }

    const numberToMoney = (value, currencyString = '', maximumFractionDigits = 2) => {
        if(currencyString) {
            return getCurrencyFormatter(currencyString, locale, maximumFractionDigits).format(value)
        }

        return getCurrencyFormatter(currency ?? 'NGN', locale, maximumFractionDigits).format(value)
    }

    return {
        isNgLocale,
        isKeLocale,
        numberToMoney,
    };
}